<script>
  import { createEventDispatcher } from "svelte";
  import Sheet from "@components/Sheet";
  import { _ } from "@services/i18n";
  import { getIntent } from "@services/speakeasy";
  import { displayTooltip, experience, voiceMode } from "@stores/global";

  export let delay = 0;
  export let title = $_("components.given_questions.title", {
    default: "Questions"
  });
  export let questions = [];

  const dispatch = createEventDispatcher();

  /**
   * Submit question text to nlu
   *
   * @param {string} payload
   */
  async function askQuestion(payload) {
    try {
      dispatch("question-asked");
      await getIntent({
        experienceId: $experience.id,
        payload,
        type: "text"
      });
    } catch (err) {
      dispatch("error", err);
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }
</script>

<style>
  .content{
    font-size: 1.6rem;
  }
  ul{
    list-style: none;
    margin: 0;
    padding: 0 0 0 1.5em;
    position: relative;
  }
  li {
    cursor: pointer;
    margin-bottom: 1em;
    opacity: 0.75;
    word-break: break-word;
  }

  li:before{
    content: "\2192";
    left: 0;
    position: absolute;
  }
  footer{
    padding: 2rem 0 0;
    position: relative;
  }
  .tooltipVisible{
    padding-top: 15rem!important;
  }

  .voiceMode{
    padding-top: 9rem;
  }
</style>

<Sheet {delay}>
  <span slot="title">{title}</span>
  <div class="content">
    <ul>
      {#each questions as question}
        <li on:click={() => askQuestion(question)}>{question}</li>
      {/each}
    </ul>
    <footer class:tooltipVisible={$displayTooltip} class:voiceMode={$voiceMode}>
      <slot name="actions" />
    </footer>
  </div>
</Sheet>
